<template>
  <div>
    <window
      ref="windowRef"
      :width="'1200px'"
      :visible="visible"
      :title="title"
      :position-top="100"
      :position-left="32"
      :actions="actions"
    >
      <Spreadsheet :jsondata="jsondata" :bus="bus" :importType="importType" ref="form" />
      <button class="btn btn-sm btn-primary mt-2" @click="onSubmit" style="background-color: #0054a6; color: white">
        {{ $t("dialogBox.upload") }}
      </button>
    </window>
  </div>
</template>
<script lang="ts">
import { Window } from "@progress/kendo-window-vue-wrapper";
import Spreadsheet from "@/app/views/_components/SpreadSheet.vue";
import { defineComponent } from "vue";
import mitt from "mitt";

export default defineComponent({
  name: "DialogBox",
  components: {
    // "kendo-dialog": Dialog,
    // "kendo-dialog-action": DialogAction,
    window: Window,
    Spreadsheet
  },
  props: {
    jsondata: {
      type: Array as () => any,
      required: true
    },
    importType: {
      type: null as any,
      required: true
    },
    title: {
      type: null as any,
      required: true
    }
  },
  data() {
    return {
      visible: true,
      bus: mitt(),
      actions: ["Pin", "Minimize", "Maximize", "Close"]
    };
  },
  methods: {
    onSubmit(): void {
      this.bus.emit("submit");
    }
  }
});
</script>
